import enTranslationErrors from "./en/translation-errors.json";
import enTranslationSurveyLinkStatus from "./en/translation-survey-link-status.json";
import enTranslationProjects from "./en/translation-projects.json";
import enTranslationSurveys from "./en/translation-surveys.json";
import enTranslationCommon from "./en/translation-common.json";
import enTranslationFilters from "./en/translation-filters.json";
import enTranslationSurveyDashboard from "./en/translation-survey-dashboard.json";
import enTranslationEmailTemplates from "./en/translation-email-templates.json";
import enTranslationSurveyStatus from "./en/translation-survey-status.json";
import enTranslationSurveyRespondentErrors from "./en/translation-survey-respondent-errors.json";
import enTranslationEmailCycles from "./en/translation-email-cycles.json";
import enTranslationManageUsers from "./en/translation-manage-users.json";
import enTranslationWelcomePage from "./en/translation-welcome-page.json";

export const eagleEnTranslation = {
  errors: enTranslationErrors,
  surveyLinkStatus: enTranslationSurveyLinkStatus,
  projects: enTranslationProjects,
  surveys: enTranslationSurveys,
  common: enTranslationCommon,
  filters: enTranslationFilters,
  surveyDashboard: enTranslationSurveyDashboard,
  emailTemplates: enTranslationEmailTemplates,
  surveyStatus: enTranslationSurveyStatus,
  surveyRespondentErrors: enTranslationSurveyRespondentErrors,
  emailCycles: enTranslationEmailCycles,
  manageUsers: enTranslationManageUsers,
  welcomePage: enTranslationWelcomePage,
};
